module.exports = __webpack_public_path__ + "static/media/characterDesign1.545ab3e2.png";